import {merge, MonoTypeOperatorFunction} from 'rxjs';
import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {debug} from '../../../utils/debug';
import {debounceWithoutComplete} from '../utils/debounceWithoutComplete';
import {subscribe} from '../utils/subscribe';
import {settingUpdate$} from '../wixSdkObservables';

export const migrationStart$ = settingUpdate$.pipe(
  filter(({type}) => type === 'migrationStart'),
  debug('migration', 'migration started'),
);
export const migrationEnd$ = settingUpdate$.pipe(
  filter(({type}) => type === 'migrationEnd'),
  debug('migration', 'migration finished'),
);

export function startMigrationTrack() {
  const isMigrating$ = merge(migrationStart$, migrationEnd$).pipe(
    map(({type}) => type === 'migrationStart'),
    startWith(false),
    shareReplay(1),
  );
  subscribe(isMigrating$);

  return function debounceMigration<T>(): MonoTypeOperatorFunction<T> {
    return debounceWithoutComplete(() => isMigrating$.pipe(filter((isMigrating) => isMigrating === false)));
  };
}
